import React from 'react';
import { connect } from 'react-redux';
import { Autocomplete, TextField } from '@mui/material';
import { selectStagingEquipment } from '../../../../redux/selectors/staging';

const EquipmentIdSelector = ({ equipment, value, setValue, renderOption }) => (
  <Autocomplete
    options={equipment}
    onChange={(_event, newValue) => {
      setValue(newValue);
    }}
    value={value}
    renderOption={renderOption}
    // eslint-disable-next-line react/jsx-props-no-spreading
    renderInput={(params) => <TextField label="Select Equipment Id" {...params} />}
    fullWidth
    selectOnFocus
  />
);

const mapStateToProps = (state, { buildingId, sortOptions }) => {
  const staging = selectStagingEquipment(state, buildingId);
  const equipment = staging.equipment
    .map((equip) => equip.equip_id)
    .filter((equipId) => equipId !== '__SKIP__');
  equipment.sort(sortOptions);
  // Filter, Sort, & Push to ensure SKIP always present and always last
  equipment.push('__SKIP__');

  return {
    equipment,
  };
};

export default connect(mapStateToProps)(EquipmentIdSelector);
